import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode; onError?: (error: unknown, info: ErrorInfo) => void };

// catches anything a screen did not expect, shows a calm page instead of a blank one, and offers a reload
export class ErrorBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: unknown, info: ErrorInfo) {
    this.props.onError?.(error, info);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="error-page" role="alert">
        <h1>Something went wrong</h1>
        <p>This page hit a problem it did not expect. Reloading usually fixes it.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload the page
        </button>
      </div>
    );
  }
}
